<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">Notificações</p>
    </div>

    <div>
      <div class="row col-12 q-col-gutter-sm">
        <div class="col-md-3 col-sm-12 col-xs-12">
          <div class="q-ml-sm text-weight-bold texto-titulo-input">
            Categoria
          </div>
          <div class="col-md-2">
            <q-select
              outlined
              class="input-new-design"
              dense
              v-model="categoria"
              :options="options"
              label="Selecione a notificação"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="q-mt-md">
      <div class="q-pt-md">
        <q-table
          table-header-class="bg-accent text-weight-bold"
          id="customers"
          :rows="rows"
          :columns="columns"
          dense
          @request="handleRequest"
          hide-pagination
          :filter="filter"
          row-key="clinteId"
          flat
          :rows-per-page-options="[0]"
          class="my-sticky-header-table"
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
            >
              Lista de Notificações</span
            >
          </template>
          <template #body-cell-link="props">
            <q-td
              :class="{ vizualisado987: props.row.dataVisualizacao != null }"
            >
              <div v-if="props.row.dados">
                <div>
                  <span v-if="props.row.dados == null">Indisponivel</span>

                  <q-btn
                    v-if="props.row.categoria == 'Gestão de Documentos'"
                    round
                    color="secondary"
                    icon="link"
                    @click="
                      enviarRota(
                        `https://${$store.state.autenticacao.cliente}.vue.multpex.com.br/${props.row.dados}`
                      )
                    "
                  />
                  <q-btn
                    v-else
                    round
                    color="secondary"
                    icon="link"
                    @click="
                      props.row.tipo == 'background'
                        ? assinarRelatorio(props.row.dados, props.row.link)
                        : encaminhar(props.row.categoria, props.row.dados)
                    "
                  />
                </div>
              </div>
              <span v-else>Indisponivel</span>
            </q-td>
          </template>
          <template #body-cell-categoriaNotificacao="props">
            <q-td
              :class="{ vizualisado987: props.row.dataVisualizacao != null }"
            >
              {{ props.row.categoria }}
            </q-td>
          </template>
          <template #body-cell-mensagem="props">
            <q-td
              :class="{ vizualisado987: props.row.dataVisualizacao != null }"
            >
              <div v-if="props.row.categoria == 'Controle Segurança Emocional'">
                {{ props.row.mensagem.split(" ").pop() == 1 ? "Péssimo" : "" }}
                {{ props.row.mensagem.split(" ").pop() == 2 ? "Ruim" : "" }}
                {{ props.row.mensagem.split(" ").pop() == 3 ? "Regular" : "" }}
                {{ props.row.mensagem.split(" ").pop() == 4 ? "Bem" : "" }}
                {{ props.row.mensagem.split(" ").pop() == 5 ? "Ótimo" : "" }}
              </div>
              <div v-else>{{ props.row.mensagem }}</div>
            </q-td>
          </template>
          <template #body-cell-dataCriacao="props">
            <q-td
              :class="{ vizualisado987: props.row.dataVisualizacao != null }"
            >
              <span>
                {{
                  props.row.dataCriacao
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </span>
              <span class="row col-12 q-ml-sm">
                {{ props.row.dataCriacao?.split(" ")[1] }}
              </span>
            </q-td>
          </template>
          <template #body-cell-excluir="props">
            <q-td
              :class="{ vizualisado987: props.row.dataVisualizacao != null }"
            >
              <q-btn
                flat
                no-caps
                color="red"
                icon="sym_o_delete"
                @click="confirmarExcluir(props.row.notificacaoId)"
              />
            </q-td>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>

    <DialogConfirmDesign
      :exibir="modalExcluir"
      mensagem="Tem certeza que deseja excluir essa Notificação?"
      @resultado="handleExcluirConfirmacao"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "notificacaoId",
    label: "Numero",
    field: "notificacaoId",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },
  {
    name: "categoriaNotificacao",
    label: "Categoria Notificação",
    field: "categoria",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },
  {
    name: "mensagem",
    label: "Mensagem Notificação",
    field: "mensagem",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },
  {
    name: "dataCriacao",
    label: "Data",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },
  {
    name: "link",
    label: "Link",
    field: "link",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },

  {
    name: "excluir",
    label: "Excluir",
    field: "excluir",
    align: "left",
    classes: (row) => (row.dataVisualizacao ? "vizualisado987" : ""),
  },
];

import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import DialogConfirmDesign from "../../components/DialogConfirmDesign.vue";

export default {
  name: "CriarCliente",
  components: { DialogConfirmDesign },
  setup() {
    const router = useRouter();

    const loading = ref(true);
    const nome = ref("");
    const store = useStore();
    const quasar = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const categoria = ref("");
    const options = ref([]);
    const modalExcluir = ref(false);
    const notificacaoIdParaExcluir = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const listarNotificacao = async (page = 0, rowsPerPage = 15) => {
      disable.value = true;
      try {
        let response = await store.dispatch("notificacao/getNotificacoes", {
          id: store.state.autenticacao.usuarioLogado.id,
          page,
          perPage: rowsPerPage,
          search: filtrar.value,
          categoria: categoria.value == "TODAS" ? "" : categoria.value,
        });
        rows.value = response.data.resultado.dados;

        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const visualizarNotificacao = async () => {
      try {
        await store.dispatch("notificacao/vizualizarNotificacao", {
          id: store.state.autenticacao.usuarioLogado.id,
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o vizualizar notificações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const confirmarExcluir = (notificacaoId) => {
      notificacaoIdParaExcluir.value = notificacaoId;
      modalExcluir.value = true;
    };

    const handleExcluirConfirmacao = async (confirmado) => {
      modalExcluir.value = false;
      if (confirmado) {
        await excluirNotificacao(notificacaoIdParaExcluir.value);
      }
      notificacaoIdParaExcluir.value = null;
    };

    const excluirNotificacao = async (notificacaoId) => {
      try {
        await store.dispatch("notificacao/excluirNotificacao", {
          notificacaoId,
        });

        quasar.notify({
          message: "Notificação excluida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarNotificacao();
      } catch (error) {
        quasar.notify({
          message: "Erro a o excluir notificação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const assinarRelatorio = async (fileUrl, rota) => {
      const url = JSON.parse(fileUrl);
      try {
        const response = await store.dispatch("notificacao/assinarRelatorio", {
          fileUrl: url,
        });

        let id = response.data.resultado.dados;

        // Remove aspas extras (caso existam)

        console.log(id);

        const baseURL = window.location.origin;

        // Passando o id como query string
        const fullURL = `${baseURL}/${rota}?id=${encodeURIComponent(
          url.includes("multpex-voucher") ? url : id
        )}`;

        window.open(fullURL, "_blank");
      } catch (error) {
        quasar.notify({
          message: "Erro ao gerar url do relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const filtrar = async () => {
      console.log("filtro");
    };

    const enviarRota = (link) => {
      const url = new URL(link);
      const queryParams = url.searchParams;
      const vencimentoEmDias = queryParams.get("vencimentoEmDias");
      const status = queryParams.get("status");
      const routeData = router.resolve({
        name: "documentos-listar",
        params: { vencimentoEmDias: vencimentoEmDias, status: status },
      });
      window.open(routeData.href, "_blank");
    };

    const encaminhar = async (categoria, link) => {
      if (
        categoria ==
        "ATV Alerta de Ferramentas com Tempo de Permanencia Excedido"
      ) {
        const url = JSON.stringify(link);
        router.push({
          name: "ferramentaria-relatorio-emprestimo",
          params: { id: url },
        });
      } else if (categoria == "ATV Alerta de Ferramenta com Problema") {
        const url = JSON.stringify(link);
        router.push({
          name: "ferramentaria-relatorio-checklist-acessorio",
          params: { id: url },
        });
      }
    };

    const handleRequest = async () => {
      listarNotificacao(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => categoria.value,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    const getCaregorias = async () => {
      try {
        const response = await store.dispatch("notificacao/getCaregorias");
        options.value = response.data.resultado.categorias;
        options.value.push("TODAS");
      } catch (error) {
        quasar.notify({
          message: "Erro a o vizualizar notificações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(listarNotificacao);
    onMounted(visualizarNotificacao);
    onMounted(getCaregorias);

    return {
      columns,
      loading,
      getCaregorias,
      listarNotificacao,
      filtrar,
      nome,
      rows,
      pagination,
      disable,
      handleRequest,
      categoria,
      router,
      excluirNotificacao,
      visualizarNotificacao,
      enviarRota,
      options,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      encaminhar,
      assinarRelatorio,
      modalExcluir,
      confirmarExcluir,
      handleExcluirConfirmacao,
    };
  },
};
</script>

<style>
a {
  text-decoration: none;
}

.vizualisado987 {
  background-color: rgba(179, 175, 175, 0.411) !important;
}
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.texto-titulo-input {
  color: #8a8a8a !important;
}
</style>
